import type { Action } from "svelte/action";
import { on } from "svelte/events";

export const useCheckForLabel = (): [action: Action<HTMLSlotElement>, hasLabel: () => boolean] => {
  let hasLabel = $state(false);
  let slotElement: HTMLSlotElement | undefined;

  const updateLabelPresence = (): void => {
    hasLabel =
      slotElement?.assignedNodes({ flatten: true }).some((node) => {
        return (
          (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE) &&
          Boolean(node.textContent?.trim())
        );
      }) ?? false;
  };

  const action: Action<HTMLSlotElement> = (node) => {
    slotElement = node;
    const cleanupListener = on(node, "slotchange", updateLabelPresence);
    updateLabelPresence();

    return {
      destroy() {
        cleanupListener();
      },
    };
  };

  return [action, () => hasLabel];
};
